import { render } from "./BankCards.vue?vue&type=template&id=99a77cf4&scoped=true"
import script from "./BankCards.vue?vue&type=script&lang=js"
export * from "./BankCards.vue?vue&type=script&lang=js"

import "./BankCards.vue?vue&type=style&index=0&id=99a77cf4&lang=scss&scoped=true"

import exportComponent from "/home/mtp/ila.amt.genova.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a77cf4"]])

export default __exports__